import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';
import df from './df_20211115';
import myPD from './myPD_20211208';

import cView from './cView';

import c20v1a from './c20v1a';
import c51v1a from './c51v1a';
import i15v1a from './i15v1a';
import i16v1a from './i16v1a';

//import ExcelJS from 'exceljs';
import myXL from './myXL_20211211';
import myWB from './myWB_20211212';
import myJP from './myJP_20211219';


export default class c30v extends cView {

$cd_stss = { // 親を上書き
  sdld_c30rListsss: {c30r:[]},
  sdld_c30rDtlsss: {c30r:[]},
  sdld_i130Listsss: {i130:[]},
  s_c30rc31s: '',
  s_word: null,
};

$id_stss = {
};

/*
static op_loadSlcList = (pd={
  elm: '',
  fst: null,
}) => 
  (pd.elm == 'c30r') ? 
    super.op_loadSlcList({
      ...pd,
      od_fmts: pd.od_fmts ?? (_d_dats => {
        let _d = {
          ..._d_dats,
          key: _d_dats.d_flds.c30rb31f, // i1zv で呼び出す際に使用
          key: _d_dats.d_flds.c30rb31f, // i1zv で呼び出す際に使用
          pfx: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
          sch: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
        };
        return _d;
      }),
    })
  : super.op_loadSlcList(pd);
*/
static op_loadSlcList = (pd={
  elm: '',
  fst: null,
}) => 
  (pd.elm == 'c30r') ? 
    super.op_loadSlcList({
      ...pd,
      od_fmts: pd.od_fmts ?? (_d_dats => {
        let _d = {
          ..._d_dats,
          key: _d_dats.d_flds._fst, // i1zv で呼び出す際に使用
          pfx: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
          sch: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
        };
        return _d;
      }),
    })
  : super.op_loadSlcList(pd);

static op_loadDtl = (pd={
  elm: '',
  key: null, // 歴対応
  fst: null, // 歴対応
}) => 
  (pd.elm == 'c30r') ?
    super.op_loadDtl({
      ...pd,
      dd_rfrss: {
        i15r: {
          elm: 'i15r',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`i15r`, `_fst = ${_d_flds.c30rbk1f}`)
            return _cnd;
          },
        },
      },
      dd_cldDefss: { // 毎回呼び出すのは、重くないか
        i1zr: {
          elm: 'i1zr',
          o_cnd: _dd_datss => {
//            let _cnd = cf.c(`i1zr`, `i1zrb31f = ${_dd_datss.c30r.d_flds._fst}`)
//            let _cnd = cf.c(`i1zr`, `i1zrb31f = ${_dd_datss.c30r.d_flds._fst} limit 30`) // 30 件までに限定
            let _cnd = cf.c(`i1zr`, `i1zrb31f = ${_dd_datss.c30r.d_flds._fst}`) + ' limit 30' // 30 件までに限定
            return _cnd;
          },
          ld_sortss: [
            { fld: 'i1zri21d', dtn: 'desc', mode: 'str'},
          ],
          dd_rfrss: {
            i10r: {
              elm: 'i10r',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1zrb41f}`)
                return _cnd;
              },
            },
          },
        },
      },
    })
  : super.op_loadDtl(pd)
;

$clp_loadLists = () =>
  (global.t?.d_viewDefs.class == 'c30v1a') ? 
    [
      c30v.op_loadSlcList({
        elm: 'c30r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('c30r') // 団体に限定
          if (global.t?.state.s_word) _cnd += ` AND (c30rc11s LIKE "%${global.t?.state.s_word}%" OR c30rc31s LIKE "%${global.t?.state.s_word}%")`
//ff.l('c30v 128: {}'.f(_cnd))
          return _cnd;
        },
      }),
      i15v1a.op_loadSlcList({
        elm: 'i15r',
      }),
      c20v1a.op_loadDtl({
        elm: 'c20r',
      }),
      i16v1a.op_loadSlcList({ // 団体一覧 excel で必要
        elm: 'i16r',
      }),
    ]
  :bf.i(global.t?.d_viewDefs.class, ['c30v2a']) ? 
    [
      cf.myRN_savePageStgs({
        sgc_pnlMode: 'dtl',
      }),
      c30v.op_loadDtl({
        elm: 'c30r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('c30r', `_fst = ${global.t?.state.sgcd_cmnStgs.c10rb31f}`)
          return _cnd;
        },
      }),
      c20v1a.op_loadDtl({
        elm: 'c20r',
      }),
    ]
  :bf.i(global.t?.d_viewDefs.class, ['c30v3a']) ? 
    [
      cf.myRN_savePageStgs({
        sgc_pnlMode: 'dtl',
        sgc_pnlPhs: 'ini',
        sgc_pageMode: 'edit',
      }),
      c30v.op_loadDtl({
        elm: 'c30r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('c30r', `_fst = ${global.t?.state.sgcd_cmnStgs.c10rb31f}`)
          return _cnd;
        },
      }),
      c20v1a.op_loadDtl({
        elm: 'c20r',
      }),
    ]
  : null
;

$clp_loadDtls = () =>
  (global.t?.d_viewDefs.class == 'c30v1a') ? 
    [
      c30v.op_loadDtl({
        elm: 'c30r',
      }),
      c30v.op_loadVsnList({ // 時間帯
        elm: 'c30r',
      }),
      i16v1a.op_loadSlcList({
        elm: 'i16r',
      }),
    ]
  :bf.i(global.t?.d_viewDefs.class, ['c30v2a', 'c30v3a']) ? 
    null
  : null
;

$clp_upds = () => 
  [
    cr.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_c30rDtlsss',
      b_vsn: true,
      dd_elmDefss: { // c10v1a・c10v2b 固有
        c30r: {
          elm: 'c30r', // elm混在に注意
//          b_setPageKey: false,
          b_setPageKey: true,
          od_insDats: pd => {
            let _d = {
              c30rbk1f: pd.c30r.d_flds.c30rbk1f ?? 10,
              c30rc11s: pd.c30r.d_flds.c30rc11s ?? '',
              c30rc12s: pd.c30r.d_flds.c30rc12s ?? '',
              c30rc31s: pd.c30r.d_flds.c30rc31s ?? '',
              c30rc33s: pd.c30r.d_flds.c30rc33s ?? '',
              c30ri11s: pd.c30r.d_flds.c30ri11s ?? '',
              c30ri13s: pd.c30r.d_flds.c30ri13s ?? '',
              c30ri21s: pd.c30r.d_flds.c30ri21s ?? '',
              c30ri22i: pd.c30r.d_flds.c30ri22s ??  0,
              c30ri31s: pd.c30r.d_flds.c30ri31s ?? '',
              c30ri32s: pd.c30r.d_flds.c30ri32s ?? '',
              c30ri33s: pd.c30r.d_flds.c30ri33s ?? '',
              c30ri34s: pd.c30r.d_flds.c30ri34s ?? '',
              c30ri41s: pd.c30r.d_flds.c30ri41s ?? '',
              c30ri42s: pd.c30r.d_flds.c30ri42s ?? '',
              c30rt21i: pd.c30r.d_flds.c30rt21i ??  0,
              c30ri21i: pd.c30r.d_flds.c30ri21i ??  0,
              c30rt22i: pd.c30r.d_flds.c30rt22i ??  0,
/*
              c30ri51s: pd.c30r.d_flds.c30ri51s ?? '',
              c30ri52s: pd.c30r.d_flds.c30ri52s ?? '', 
              c30ri53s: pd.c30r.d_flds.c30ri53s ?? '',
*/
              c30ri61s: pd.c30r.d_flds.c30ri61s ?? '',
              c30ri71d: pd.c30r.d_flds.c30ri71d ?? '',
              c30ri71s: pd.c30r.d_flds.c30ri71s ?? '',
              c30ri81s: pd.c30r.d_flds.c30ri81s ?? '',
              c30ri91i: pd.c30r.d_flds.c30ri91i ??  0,
              c30ri92i: pd.c30r.d_flds.c30ri92i ??  0,
              c30ri93i: pd.c30r.d_flds.c30ri93i ??  0,
              c30ri94s: pd.c30r.d_flds.c30ri94s ??  0,
              c30ria1i: pd.c30r.d_flds.c30ria1i ??  0,
              c30rib1i: pd.c30r.d_flds.c30rib1i ??  0,
              c30ric1s: pd.c30r.d_flds.c30ric1s ?? '',
              c30rid1s: pd.c30r.d_flds.c30rid1s ?? '',
              c30rid2s: pd.c30r.d_flds.c30rid2s ?? '',
              c30rie1i: pd.c30r.d_flds.c30rie1i ??  0,
              c30rie2s: pd.c30r.d_flds.c30rie2s ?? '',
              c30rie3i: pd.c30r.d_flds.c30rie3i ??  0,
              c30rie4i: pd.c30r.d_flds.c30rie4i ??  0,
              c30rie5i: pd.c30r.d_flds.c30rie5i ??  0,
              c30rif1i: pd.c30r.d_flds.c30rif1i ??  0,
              c30rif1m: pd.c30r.d_flds.c30rif1m ??  0,
              c30rig1s: ff.myCM_cnv('lwr', pd.c30r.d_flds.c30rig1s) ?? '',
              c30rig2s: ff.myCM_cnv('lwr', pd.c30r.d_flds.c30rig2s) ?? '',
              c30rig3s: ff.myCM_cnv('lwr', pd.c30r.d_flds.c30rig3s) ?? '',
              c30rih1i: pd.c30r.d_flds.c30rih1i ?? 0,
              c30rih2i: pd.c30r.d_flds.c30rih2i ?? 0,
              c30rih3i: pd.c30r.d_flds.c30rih3i ?? 0,
            };
//ff.l('376: {}'.f(_d));
            return _d;
          },
        },
      },
      op_atrAll: () => new Promise( _o_end1 => {
        let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
        cf.myCB_callQrys({ // 暫定的に、毎回実行
          l_tgts: [
            'c10ri11s', //メールアドレス1
          ],
          d_vals: {
            c10rb31f: global.t?.state.sgc_pageFst,
            c10rc11s: '1',
            c10ri11s: _d_c30rs.d_flds.c30rig1s ?? '',
          },
        })
        .then(() => {
          cf.myCB_callQrys({ // 暫定的に、毎回実行
            l_tgts: [
              'c10ri11s', //メールアドレス2
            ],
            d_vals: {
              c10rb31f: global.t?.state.sgc_pageFst,
              c10rc11s: '2',
              c10ri11s: _d_c30rs.d_flds.c30rig2s ?? '',
            },
          })
          .then(() => {
            cf.myCB_callQrys({ // 暫定的に、毎回実行
              l_tgts: [
                'c10ri11s', //メールアドレス3
              ],
              d_vals: {
                c10rb31f: global.t?.state.sgc_pageFst,
                c10rc11s: '3',
                c10ri11s: _d_c30rs.d_flds.c30rig3s ?? '',
              },
            })
            .then(() => {
              if (ff.i(global.t?.d_viewDefs.class, ['c30v2a', 'c30v3a'])) {
                let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
                let _c30rc11s = _d_c30rs.d_flds.c30rc11s;
                let _c30rc31s = _d_c30rs.d_flds.c30rc31s;
                let _c30rig1s = _d_c30rs.d_flds.c30rig1s;
                let _c30rig2s = _d_c30rs.d_flds.c30rig2s;
                let _c30rig3s = _d_c30rs.d_flds.c30rig3s;
                let _ttl = `メールアドレス登録のご連絡 (${global.t?.state.sgcd_cmnStgs.c20r_pfx})`;
                let _msg = 
`団体番号：${_c30rc11s}
${_c30rc31s} 様

この度は、メールアドレスのご登録をありがとうございます。
登録されたアドレスをご連絡します。

-----------------------------------------------------------

　登録されたメールアドレス

　主　： ${_c30rig1s}
　副１： ${_c30rig2s}
　副２： ${_c30rig3s}

-----------------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`;

                const _l_tos = [];
                if (ff.f(_c30rig1s)) _l_tos.push(_c30rig1s);
                if (ff.f(_c30rig2s)) _l_tos.push(_c30rig2s);
                if (ff.f(_c30rig3s)) _l_tos.push(_c30rig3s);
                const _l_bccs = [ic.g_mail];
                if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
                cf.myCB_call_eml(
                  _l_tos,
                  _ttl,
                  _msg,
                  _l_bccs
                )
                .then(() => {
                  _o_end1();
                });
              }
              else {
                _o_end1();
              };
            });
          });
        });
      })
    }),
  ]
;

_op_updc30rc11s = (pd={
  i15rc31s: null,
}) => new Promise( _o_end1 => {
  let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
  cf.myRN_setDat('sdld_c30rDtlsss', _d_c30rs, _d_c30rs => {
    let _d = {
      c30rc11s: `${_d_c30rs.d_flds.i15rc31s} - ${_d_c30rs.d_flds.c30rc12s}`,
    };
    return _d;
  })
  .then(() => {
    _o_end1();
  });
});

$clp_dlts = () => 
  [
    new Promise( _o_end1 => {
      let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
      cf.myRN_setDat('sdld_c30rDtlsss', _d_c30rs, _d_c30rs => {
        let _d = {
          c30rcz1i: 0,
        };
        return _d;
      })
      .then(() => {
        Promise.all(global.t?.$clp_upds())
        .then(_o_end1);
      });
    }),
  ]
;

$opb_chk = (pb_msg=true) => new Promise( _o_end1 => { // 
  ff.myCM_srl([
    () => new Promise( _o_end2 => { // 必須項目の入力確認
      let _d_c30rs = global.t?.state.sdld_c30rDtlsss?.c30r[0];
      if (
        ff.f(_d_c30rs.d_flds.c30rc31s) == false ||
        ff.n(_d_c30rs.d_flds.c30rbk1f) < 1 ||
        ff.f(_d_c30rs.d_flds.c30rc12s) == false
      ) {
        if (pb_msg) alert('入力されていない項目があるため、指定された操作を行うことができません');
        _o_end2(false);
      } else { _o_end2(true); };
    }),
/*
    () => new Promise( _o_end2 => { // 団体番号の重複確認
      let _d_c30rs = global.t?.state.sdld_c30rDtlsss?.c30r[0];
      let _cnd = cf.c('c30r', `c30rbk1f = ${_d_c30rs.d_flds.c30rbk1f} AND c30rc12s = "${_d_c30rs.d_flds.c30rc12s}"`)
ff.l('c30v 362: {}'.f(_cnd))
      cf.myCB_call_slc({
        elm: 'c30r',
        n_dms: 3,
        cnd: _cnd,
      })
      .then( _ld_fldss => {
        let _b_sgl = true;
        let _name = null; 
        _ld_fldss.map( _d_flds => {
          if ( global.t?.state.sgc_pageMode == 'new' || _d_flds._fst != global.t?.state.sgc_pageFst ) { // 一度登録したコードを変更することを考慮
            _b_sgl = false;
            _name = _d_flds.c30rc31s;
          };
        })
        if (
          _b_sgl == false
        ) {
          if (pb_msg) alert(`団体番号が他の団体(${_name})と重複しているため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      })
    }),
*/
    () => new Promise( _o_end2 => { // メールアドレスの重複確認
      let _d_c30rs = global.t?.state.sdld_c30rDtlsss?.c30r[0];
      let _c30rig1s = ff.f(_d_c30rs.d_flds.c30rig1s) ? ff.myCM_cnv('lwr', _d_c30rs.d_flds.c30rig1s) : 'None1';
      let _c30rig2s = ff.f(_d_c30rs.d_flds.c30rig2s) ? ff.myCM_cnv('lwr', _d_c30rs.d_flds.c30rig2s) : 'None2';
      let _c30rig3s = ff.f(_d_c30rs.d_flds.c30rig3s) ? ff.myCM_cnv('lwr', _d_c30rs.d_flds.c30rig3s) : 'None3';
      let _cnd = null;
//      _cnd = cf.c('c30r', `c30rig1s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}") OR c30rig2s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}") OR c30rig3s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}")`);
      _cnd = cf.c('c30r', `t_c30r._fst <> ${global.t?.state.sgcd_cmnStgs.c10rb31f} AND (t_c30r.c30rig1s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}") OR t_c30r.c30rig2s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}") OR t_c30r.c30rig3s IN ("${_c30rig1s}", "${_c30rig3s}", "${_c30rig2s}"))`);
//ff.l('c30v 395: {}, {}, {}'.f(_cnd, global.t?.state.sgcd_cmnStgs.c10rb31f))
      cf.myCB_call_slc({
        elm: 'c30r',
        n_dms: 3,
        cnd: _cnd,
      })
      .then( _ld_fldss => {
        let _b_sgl = true;
        let _name = null; 
        _ld_fldss.map( _d_flds => {
          if (
            global.t?.state.sgc_pageMode == 'new' || 
            _d_flds._fst != global.t?.state.sgc_pageFst
          ) { // 一度登録したコードを変更することを考慮
            _b_sgl = false;
            _name = _d_flds.c30rc31s;
          };
        })
        if (
          _b_sgl == false
        ) {
          if (pb_msg) alert(`メールアドレスが他の団体(${_name})と重複しているため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      })
    }),
  ])
  .then( _b_res => {
    cf.myRN_setStt({
      sgcb_chk: _b_res,
    })
    .then(() => {
      _o_end1(_b_res);
    });
  });
}) 

_eptPdf1 = () => {
  cf.s();

  let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
  let _file = `メールアドレスご登録の手引き_${ff.myCM_pdd(_d_c30rs.d_flds.c30rsc11s, 6, '0')}_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
  let _ld_iss = []

  let _n_row = 0;
  _ld_iss.push({ type: 'text', pfx: `メールアドレスご登録の手引き`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });

  _n_row = 3;
  _ld_iss.push({ type: 'text', pfx: `１．パソコン、もしくはスマートフォンより、下記アドレスの登録画面を開いてください。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  let _url = String(ic.g_dmn).f(global.t?.state.sgcd_stgs?.subDmn2)
  let _id = ff.myCM_cnv('ecd-6dgt', { n_nbr: _d_c30rs.d_flds._fst });
//  _url = `${_url}/c00v1a?id=${_id}`;
  _url = `${_url}/c00vm?id=${_id}`;

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `【URL】　${_url}`,  n_cmn: 3, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 50, aln: 'ctr', b_frm: true});

  _n_row += 1.5;
  _ld_iss.push({ type: 'text', pfx: `▼QRコードからページを開ける方は以下をご利用ください`,  n_cmn: 3, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 50, aln: 'ctr', b_frm: false});
  _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 3, n_row: _n_row, n_rowCnt: 7, n_cmnCnt: 50, aln: 'ctr', b_frm: true});
  _n_row += 1.0;
  _ld_iss.push({ type: 'qr', pfx: _url, n_cmn: 23, n_row: _n_row, n_rowCnt: 7});
  _n_row += 6;

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `２．登録画面においてメール登録用確認コードを入力し、ログイン用のメールアドレスを`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　設定してください。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  let _pwd = ff.myCM_cnv('pwd', {n_nbr: _d_c30rs.d_flds._fst})

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `団体番号`,  n_cmn: 7, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 18, aln: 'ctr', b_frm: true});
  _ld_iss.push({ type: 'text', pfx: `${_d_c30rs.d_flds.c30rc11s}`,  n_cmn: 25, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 24, aln: 'ctr', b_frm: true});
  _n_row += 1.5;
  _ld_iss.push({ type: 'text', pfx: `団体名`,  n_cmn: 7, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 18, aln: 'ctr', b_frm: true});
  _ld_iss.push({ type: 'text', pfx: `${_d_c30rs.d_flds.c30rc31s}`,  n_cmn: 25, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 24, aln: 'ctr', b_frm: true});
  _n_row += 1.5;
  _ld_iss.push({ type: 'text', pfx: `メール登録用確認コード`,  n_cmn: 7, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 18, aln: 'ctr', b_frm: true});
  _ld_iss.push({ type: 'text', pfx: `${_pwd}`,  n_cmn: 25, n_row: _n_row, n_rowCnt: 1.5, n_cmnCnt: 24, aln: 'ctr', b_frm: true, });

  _n_row += 1.5;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　※ 設定したメールアドレスは、「設定画面」からいつでも変更出来ます。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  _n_row += 1;
  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `３．登録ボタンを押すと、メールアドレスが登録されます。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　正常にメールアドレスの登録が完了すると、「メールアドレス登録のご連絡」`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　というタイトルの確認メールが５分以内に自動で届きます。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　※ 上記のメールが届かない場合は、正常に登録されていない可能性がございます。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　　その場合は、もう一度最初からお試しください。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　【ご注意】`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　・メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　　迷惑メールとして判定されていないかのご確認をお願いします。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　・PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は、`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　　「c-supportsys.com」`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　　から届くメールの受信許可設定をお願いいたします。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　※ 何度試してもうまくメールが登録されない場合は、お手数ですが、窓口まで`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `　　　ご相談ください。`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });

  _n_row += 1;
  _n_row += 1;
  _n_row += 1;
  _ld_iss.push({ type: 'text', pfx: `【この用紙は、メール登録完了後、処分して頂いて問題ありません】`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, n_cmnCnt: 54, aln: 'ctr'});

  _ld_iss.push({ type: 'pstCvsToPdf' });
  _ld_iss.push({ type: 'savePdf' });

  myPD.myPD_dwlFile({
    file: _file,
    ld_iss: _ld_iss,
    d_inis: {
      orientation: 'portrait',
    },
  })
  .then(() => {
    cf.h();
  });
};

_eptExl1 = async () => {

  cf.s();

  const _ld_hdrss = [
    { key:  1, header: '団体番号', width: 20, style: {} },
    { key:  2, header: '団体名', width: 20, style: {}  },
    { key:  3, header: '団体かな', width: 20, style: {}  },
    { key:  4, header: '代表者名', width: 20, style: {}  },
    { key:  5, header: '代表者かな', width: 20, style: {}  },
    { key:  6, header: '郵便番号', width: 20, style: {}  },
    { key:  7, header: '都道府県', width: 20, style: {}  },
    { key:  8, header: '市区町番地', width: 20, style: {}  },
    { key:  9, header: '建物・部屋番等', width: 20, style: {}  },
    { key: 10, header: '電話（主）', width: 20, style: {}  },
    { key: 11, header: '電話（副）', width: 20, style: {}  },
    { key: 12, header: 'メール（主）', width: 20, style: {}  },
    { key: 13, header: 'メール（副1）', width: 20, style: {}  },
    { key: 14, header: 'メール（副2）', width: 20, style: {}  },
    { key: 15, header: '次回更新日', width: 20, style: {}  },
    { key: 16, header: '１年目確認', width: 20, style: {}  },
    { key: 17, header: '２年目確認', width: 20, style: {}  },
    { key: 18, header: '３年目確認', width: 20, style: {}  },
    { key: 19, header: '更新備考', width: 20, style: {}  },
    { key: 20, header: 'カテゴリ', width: 20, style: {}  },
    { key: 21, header: '活動内容', width: 20, style: {}  },
    { key: 22, header: '活動備考', width: 20, style: {}  },
    { key: 23, header: '活動頻度', width: 20, style: {}  },
    { key: 24, header: '活動時間帯', width: 20, style: {}  },
    { key: 25, header: '活動曜日', width: 20, style: {}  },
    { key: 26, header: '会員構成', width: 20, style: {}  },
    { key: 27, header: '会員構成その他', width: 20, style: {}  },
    { key: 28, header: '男性人数', width: 20, style: {}  },
    { key: 29, header: '女性人数', width: 20, style: {}  },
    { key: 30, header: 'こども人数', width: 20, style: {}  },
    { key: 31, header: '会費', width: 20, style: {}  },
    { key: 32, header: '会員募集', width: 20, style: {}  },
    { key: 33, header: '指導者名', width: 20, style: {}  },
    { key: 34, header: '指導者かな', width: 20, style: {}  },
    { key: 35, header: '利用制限', width: 20, style: {}  },
  ];

  let _ld_bdyss = [];
  for await (let [_c30rIdx, _d_c30rSlcs] of ff.e(global.t?.state.sdld_c30rSlcListsss.c30r)) {
    await c30v.op_loadDtl({
      elm :'c30r',
      fst: _d_c30rSlcs.d_flds._fst,
    })
    .then(() => {
      let _d_c30rDtls = global.t?.state.sdld_c30rDtlsss.c30r[0];
      _ld_bdyss.push({
        1: _d_c30rDtls.d_flds.c30rc11s,
        2: _d_c30rDtls.d_flds.c30rc31s,
        3: _d_c30rDtls.d_flds.c30rc33s,
        4: _d_c30rDtls.d_flds.c30ri11s,
        5: _d_c30rDtls.d_flds.c30ri13s,
        6: _d_c30rDtls.d_flds.c30ri31s,
        7: _d_c30rDtls.d_flds.c30ri32s,
        8: _d_c30rDtls.d_flds.c30ri33s,
        9: _d_c30rDtls.d_flds.c30ri34s,
      10: _d_c30rDtls.d_flds.c30ri41s,
      11: _d_c30rDtls.d_flds.c30ri42s,
      12: _d_c30rDtls.d_flds.c30rig1s,
      13: _d_c30rDtls.d_flds.c30rig2s,
      14: _d_c30rDtls.d_flds.c30rig3s,
      15: _d_c30rDtls.d_flds.c30ri71d,
      16: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rih1i'), // cnv
      17: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rih2i'), // cnv
      18: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rih3i'), // cnv
      19: _d_c30rDtls.d_flds.c30ri71s,
      20: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rib1i', global.t?.state.sdld_i16rSlcListsss?.i16r), // cnv
      21: _d_c30rDtls.d_flds.c30ric1s,
      22: _d_c30rDtls.d_flds.c30ri81s,
      23: `${cf.myRN_cnvFldVal(_d_c30rDtls, 'c30ri91i')} ${cf.myRN_cnvFldVal(_d_c30rDtls, 'c30ri92i')}回`,
      24: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30ri93i'), // cnv
      25: _d_c30rDtls.d_flds.c30ri94s,
      26: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rie1i'),
      27: _d_c30rDtls.d_flds.c30rie2s,
      28: _d_c30rDtls.d_flds.c30rie3i,
      29: _d_c30rDtls.d_flds.c30rie4i,
      30: _d_c30rDtls.d_flds.c30rie5i,
      31: `${cf.myRN_cnvFldVal(_d_c30rDtls, 'c30rif1i')} ${_d_c30rDtls.d_flds.c30rif1m}円`, // 
      32: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30ria1i'), // cnv
      33: _d_c30rDtls.d_flds.c30rid1s,
      34: _d_c30rDtls.d_flds.c30rid2s,
      35: cf.myRN_cnvFldVal(_d_c30rDtls, 'c30ri21s'),
      });
    });
  };

  myXL.myXL_dwlFile({
    file: `団体一覧_${ff.myDT_getDate('today').replace(/-/g, '')}.xlsx`,
    n_vsn: 2,
    sht: 'sheet1',
    ld_hdrss: _ld_hdrss,
    ld_bdyss: _ld_bdyss,
  })
  .then(() => {
    cf.h();
  });

};

render() {
//ff.l('320: {}'.f(global.t?.state.sdld_c30rDtlsss))

/*
myJP.myJP_getArs('1600022')
.then( _d_ars => {
ff.l('606: {}'.f(_d_ars));
});
*/

//ff.l('643: {}'.f(global.t?.state.sgcd_stgs?._05010100))

  return (
    ce.c(ce.RootDtl, 
    /* ----------------------------------------------------------------------------------------------------
    スタッフ用 団体登録
    ---------------------------------------------------------------------------------------------------- */
    (global.t?.d_viewDefs.class == 'c30v1a') ?
      {
        key: -1,
        d_hdrs: {
          pfx:
            (global.t?.state.sgc_pnlMode == 'list') ?  
              '団体一覧・新規登録'
            : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?  
              '新規団体登録'
            : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode != 'new') ?  
              '団体情報詳細・変更・削除'
            : null,
          d_subs: 
            ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
              {
                iconName: 'users',
                pfx: 'ユーザ切替',
                o_onPrs: () => {
                  let _d_pageInfs = {
                    sgc_pageRole: global.t?.state.sgc_pageRole,
                    sgc_pageName: 'c00v2a',
                    sgc_pageMode: 'show',
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                },
              }
            : null,
        },
        d_bdys: {
          l_clds: [

            ce.c(ce.Pnl, {
              key: -1,
              mode: 'list',
              b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
              d_srls: {
                state: 'sdld_c30rSlcListsss',
              },
              d_hdrs: {
                d_ctrs: {
                  l_clds: [
                    ce.c(ce.Inp, cf.f('c30rc31s', {
                      pfx: '団体番号・名',
                      type: 'Inp',
                      key: -1, 
                      b_vsb: true,
                      b_edit: true,
                      b_row: true,
                      b_rvs: true,
                      state: 's_word',
                    })),
                    ce.c(ce.BtnIconPfx, {
                      key: -5, 
                      b_vsb: true,
                      b_row: (ic.g_dvcMode == 's' ) ? false : true,
                      iconName: 'search',
                      pfx: '検索',
                      o_onPrs: () => global.t?.op_loadListAll(),
                    }),
                  ],
                },
                d_lefts: {
                  l_clds: [
                    ce.c(ce.BtnIconPfx, {
                      key: -1,
                      pfx: '団体一覧（EXCEL）',
                      b_vsb: (bf.i(global.t?.state.sgc_pageMode, ['show'])) ? true : false,
                      b_row: true,
                      iconName: 'file-o',
                      o_onPrs: () => {
                        cf.myRN_showMdl({
                          mdl: 'cfm',
                          msg: 'ファイルのダウンロードは時間を要しますが、宜しいですか？',
                          ld_btnss: [
                            {
                              pfx: 'はい',
                              o_onPrs: global.t?._eptExl1,
                            },
                            {
                              pfx: 'いいえ',
                              o_onPrs: () => {
                              },
                            }
                          ]
                        });
                      },
                      d_stlCtas: {
                        marginRight: ic.s(2),
                      },
                    })
                  ],
                },
              },
              d_btms: {
                d_news: {
                  elm: 'c30r',
                  pfx: '新規団体を登録',
                  state: 'sdld_c30rDtlsss',
                  d_insFlds: {
                    ...cf.e('c30r').d_insFlds, 
                  },
                },
              },
              d_bdys: {            
                d_msgBfrs: {
//                  pfx: `【団体情報の確認・変更・削除】・・・各団体番号を押すと詳細画面に移動し、変更、削除もその画面で行えます。`,
                  pfx: `■【団体情報の確認・変更・削除】･･･各団体番号を押すと詳細画面に移動し、変更、削除もその画面で行えます。`,
                  n_mgnTop: ic.s(1),
                },
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                  }, 
                    ce.c(cr.InpTree, {
                      key: -1,
                      state: 'sdld_c30rSlcListsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_row: true,
                          b_hzl: false,
                          b_rootHdr: true,
                          b_ttl: false,
                          d_stlHdrRows: {
                            height: ic.s(1.8),
                          },
                          d_stlBdyRows: {
                            height: ic.s(2.2),
                            marginTop: ic.s(0.2)
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rc11s', {
                              b_edt: false,
                              b_key: true,
                              pfx: '団体番号',
                              d_hdrs: { n_w: ic.s(7) },
                              d_bdys: { n_w: ic.s(7) },
                            }),
                            cf.f('c30rc31s', {
                              b_edt: false,
                              pfx: '団体名',
                              d_hdrs: { n_w: ic.s(15) },
                              d_bdys: { n_w: ic.s(15) },
                            }),
                          ]),
                        },
                      },
                    }),
                  )
                ],
              },
            }),

            ce.c(ce.Pnl, {
              key: -2,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_hdrs: {
                d_lefts: {
                  l_clds: [
                    ce.c(ce.BtnIconPfx, {
                      key: -1,
                      pfx: 'メールアドレス登録の手引き（PDF）',
                      b_vsb: (bf.i(global.t?.state.sgc_pageMode, ['show'])) ? true : false,
                      b_row: true,
                      iconName: 'file-o',
                      o_onPrs: global.t?._eptPdf1,
                      d_stlCtas: {
                        marginLeft: ic.s(2),
                      },
                    })
                  ],
                },
                d_htys: {
                  elm: 'c30r',
                  ld_iss: global.t?.state.sdld_c30rVsnListsss?.c30r,
                  op_loadDtl: c30v.op_loadDtl,
                },
              },
              d_btms: {
                b_dlt: true,
              },
              d_bdys: {            
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                    d_stlCtas: {
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                    },
                  }, [

                    bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
                      ce.c(ce.Msg, {
                        key: -5,
                        pfx: '＊：必須項目',
                        d_stlCtas: {
                          position: 'absolute',
                          top: ic.m(1),
                          right: ic.m(1),
                          zIndex: ic.gn_zIdxBdy + 1,
                          width: ic.s(6),
                        },
                        d_stlPfxs: {
                          color: ic.o_getCcd('e'),
                        },
                      })
                    : null,

                    ce.c(cr.InpTree, {
                      key: -10,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_row: true,
                          d_cmns: {
                            n_cnt: 1,
                          },
                          d_stlRows: {
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rc31s', {
                              pfx: '団体名',
                              n_col: 50,
                              d_lbls: {
                                b_rqr: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.8),
                              },
                              d_hdrs: {
                                n_w: ic.s(7),
                                n_h: ic.s(3.2),
                                d_stlPfxs: {
                                  fontSize: ic.s(1.8),
                                },
                              },
                              d_bdys: { 
                                n_w: ic.s(56), 
                                n_h: ic.s(3.2)
                              },
                            }), 
                            cf.f('c30rc33s', {
                              pfx: 'かな',
                              n_col: 54,
                              d_hdrs: {
                                n_w: ic.s(3),
                                n_h: ic.s(2.2)
                              },
                              d_bdys: {
                                n_w: ic.s(61),
                                n_h: ic.s(2.2)
                              },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Lbl, {
                      key: -20,
                      pfx: '団体プロフィール',
                      b_rvs: true,
                      d_stlCtas: {
                        width: global.t?.state.sgcd_dmns.n_bdyW,
                        height: ic.s(2),
                        borderWidth: 0,
                        borderTopWidth: ic.b(1.6),
                        borderColor: ic.o_getCcd('d'),
                        marginTop: ic.s(0.5),
                        marginBottom: ic.s(0.25),
                      },
                      d_stlLbls: {
                        backgroundColor: ic.o_getCcd('d'),
                        width: ic.s(8),
                        height: ic.s(2),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -30,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 4,
                            b_hzl: true,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rbk1f', { // 団体種別
                              pfx: '団体番号',
                              bsd: '-',
                              ld_iss: global.t?.state.sdld_i15rSlcListsss?.i15r,
                              o_onChg: _d_dats => {
                                let _d_i15rs = _d_dats.dd_stgss.c30rbk1f.d_rfrs;
//ff.l(`821: {}`.f(_d_i15rs))
                                cf.myRN_setDat('sdld_c30rDtlsss', global.t?.state.sdld_c30rDtlsss?.c30r[0], _d_c30rs => {
                                  return {
                                    i15rc31s: _d_i15rs.d_flds.i15rc31s, 
                                  }
                                })
                                .then(() => {
                                  global.t?._op_updc30rc11s();
                                });
                              },
                              d_lbls: {
                                b_rqr: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                              },
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(4) },
                            }), 
                            cf.f('c30rc12s', { // 団体コード
                              pfx: '',
                              o_onChg: _d_dats => {
                                global.t?._op_updc30rc11s();
                              },
                              d_hdrs: { n_w: ic.s(0) },
                              d_bdys: { n_w: ic.s(6) },
                            }), 
                            cf.f('c30ri11s', {
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(11) },
                            }), 
                            cf.f('c30ri13s', {
                              pfx: 'かな',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(11+21) },
                            }), 

                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -35,
                    }),

                    ce.c(cr.InpTree, {
                      key: -40,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 2,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri31s', { // 郵便番号
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(7) },
                              b_row: true,
                            }), 

                            cf.f('c30rBtn1', {
                              pfx: '住所を検索',
                              b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                              b_ttl: false,
                              o_onPrs: _d_dats => {
                                if (ff.f(_d_dats.d_flds.c30ri31s)) { // 郵便番号が設定されている場合
                                  myJP.myJP_getArs(_d_dats.d_flds.c30ri31s)
                                  .then( _d_arss => {
                                    cf.myRN_setDat('sdld_c30rDtlsss', _d_dats, _d_c30rs => {
                                      let _d = {
                                        c30ri32s: `${_d_arss.ars1}`,
                                        c30ri33s: `${_d_arss.ars2}${_d_arss.ars3}`,
                                      };
                                      return _d;
                                    });
                                  });
                                };
                              },
                              d_hdrs: { n_w: ic.s(0) },
                              d_bdys: { n_w: ic.s(6) },
                            }), 

                          ]),
                        },
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -50,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 3,
                            b_hzl: true,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri32s', { // 都道府県
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(6) },
                            }), 
                            cf.f('c30ri33s', { // 市区町番地
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(16) },
                            }), 
                            cf.f('c30ri34s', { // 建物・部屋番等
                              d_hdrs: { n_w: ic.s(7) },
                              d_bdys: { n_w: ic.s(16+10) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -55,
                    }),

                    ce.c(cr.InpTree, {
                      key: -60,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 2,
                            b_hzl: true,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri41s', { // 電話（主）
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(11) },
                            }), 
                            cf.f('c30ri42s', { // 電話（副）
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(11+32) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -65,
                    }),

                    ce.c(cr.InpTree, {
                      key: -70,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 3,
                            b_hzl: true,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rig1s', { // メール（主）
                              d_hdrs: { n_w: ic.s(6) },
                              d_bdys: { n_w: ic.s(11+4) },
                            }), 
                            cf.f('c30rig2s', { // メール（副1）
                              d_hdrs: { n_w: ic.s(6) },
                              d_bdys: { n_w: ic.s(11+4) },
                            }), 
                            cf.f('c30rig3s', { // メール（副2）
                              d_hdrs: { n_w: ic.s(6) },
                              d_bdys: { n_w: ic.s(11+4+1) },
                            }), 

                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Lbl, {
                      key: -80,
                      pfx: '更新',
                      b_rvs: true,
                      d_stlCtas: {
                        width: global.t?.state.sgcd_dmns.n_bdyW,
                        height: ic.s(2),
                        borderWidth: 0,
                        borderTopWidth: ic.b(1.6),
                        borderColor: ic.o_getCcd('d'),
                        marginTop: ic.s(0.5),
                        marginBottom: ic.s(0.25),
                      },
                      d_stlLbls: {
                        backgroundColor: ic.o_getCcd('d'),
                        width: ic.s(8),
                        height: ic.s(2),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -90,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 5,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri71d', { // 次回更新日
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(9) },
                            }), 
                            cf.f('c30rih1i', { // 確認１回目
                              pfx: '１年目確認',
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(4) },
                              o_ccd: _d_dats => (_d_dats.d_flds.c30rih1i == 1) ? ic.o_getCcd('e') : ic.o_getCcd('d'),
                            }), 
                            cf.f('c30rih2i', { // 確認２回目
                              pfx: '２年目確認',
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(4) },
                              o_ccd: _d_dats => (_d_dats.d_flds.c30rih2i == 1) ? ic.o_getCcd('e') : ic.o_getCcd('d'),
                            }), 
                            cf.f('c30rih3i', { // 確認３回目
                              pfx: '３年目確認',
                              d_hdrs: { n_w: ic.s(5) },
                              d_bdys: { n_w: ic.s(4+23) },
                              o_ccd: _d_dats => (_d_dats.d_flds.c30rih3i == 1) ? ic.o_getCcd('e') : ic.o_getCcd('d'),
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -95,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 5,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri71s', { // 次回更新日
                              pfx: '備考',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(62) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Lbl, {
                      key: -97,
                      pfx: '活動詳細',
                      b_rvs: true,
                      d_stlCtas: {
                        width: global.t?.state.sgcd_dmns.n_bdyW,
                        height: ic.s(2),
                        borderWidth: 0,
                        borderTopWidth: ic.b(1.6),
                        borderColor: ic.o_getCcd('d'),
                        marginTop: ic.s(0.5),
                        marginBottom: ic.s(0.25),
                      },
                      d_stlLbls: {
                        backgroundColor: ic.o_getCcd('d'),
                        width: ic.s(8),
                        height: ic.s(2),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -100,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 2,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rib1i', {
                              ld_iss: global.t?.state.sdld_i16rSlcListsss?.i16r,
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(11) },
                            }), 
                            cf.f('c30ric1s', {
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(21+24) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -105,
                    }),

                    ce.c(cr.InpTree, {
                      key: -110,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 1,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri81s', {
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(21+41) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -115,
                    }),

                    ce.c(cr.InpTree, {
                      key: -120,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 4,
                            b_hzl: true,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30ri91i', {
                              pfx: '活動頻度',
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(3) },
                            }), 
                            cf.f('c30ri92i', {
                              pfx: '',
                              bsd: '回',
                              d_hdrs: { n_w: ic.s(0) },
                              d_bdys: { n_w: ic.s(5) },
                            }), 
                            cf.f('c30ri93i', {
                              pfx: '時間帯',
                              d_hdrs: { n_w: ic.s(3) },
                              d_bdys: { n_w: ic.s(6) },
                            }), 
                            cf.f('c30ri94s', {
                              pfx: '曜日',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(16+25) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -125,
                    }),

                    ce.c(cr.InpTree, {
                      key: -130,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 4,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rie1i', {
                              pfx: '会員構成',
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(9) },
                            }), 
                            cf.f('c30rie3i', {
                              pfx: '男性',
                              bsd: '人',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(5) },
                            }), 
                            cf.f('c30rie4i', {
                              pfx: '女性',
                              bsd: '人',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(5) },
                            }), 
                            cf.f('c30rie5i', {
                              pfx: 'こども',
                              bsd: '人',
                              d_hdrs: { n_w: ic.s(3) },
                              d_bdys: { n_w: ic.s(5+29) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -135,
                    }),

                    ce.c(cr.InpTree, {
                      key: -140,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 3,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rif1i', {
                              pfx: '会費',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(4) },
                            }), 
                            cf.f('c30rif1m', {
                              pfx: '',
                              bsd: '円',
                              d_hdrs: { n_w: ic.s(0) },
                              d_bdys: { n_w: ic.s(6) },
                            }), 
                            cf.f('c30ria1i', {
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(6+42) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -145,
                    }),

                    ce.c(cr.InpTree, {
                      key: -150,
                      state: 'sdld_c30rDtlsss',
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 3,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rid1s', { // 指導者名
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(11) },
                            }), 
                            cf.f('c30rid2s', { // 指導者
                              pfx: 'かな',
                              d_hdrs: { n_w: ic.s(2) },
                              d_bdys: { n_w: ic.s(11+12) },
                            }), 
                            cf.f('c30ri21s', { // 利用制限
                              d_hdrs: { n_w: ic.s(4) },
                              d_bdys: { n_w: ic.s(20) },
                            }), 
                          ]),
                        },
                      },
                    }),

                  ])

                ],
              },
            }),
          ],
        }
      }
    /* ----------------------------------------------------------------------------------------------------
    団体用 設定
    ---------------------------------------------------------------------------------------------------- */
    : (global.t?.d_viewDefs.class == 'c30v2a') ?
      {
        key: -20,
        d_hdrs: {
          pfx: '設定',
        },

        d_bdys: {
          l_clds: [

            ce.c(ce.Pnl, {
              key: -20,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_btms: {
                b_rtn: (global.t?.state.sgc_pageMode == 'show') ? false : true,
                name: 'メールアドレス',
//                pfx: 'メールアドレスの変更',
                n_btnW: ic.s(14),
              },
              d_bdys: {            
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                  }, [

                    ce.c(ce.Msg, {
                      key: -10,
                      b_vsb: true,
                      true : false,
                      pfx: `団体名：${(global.t?.state.sdld_c30rDtlsss?.c30r[0]) ? global.t?.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s : ''}`,
                      stlCta: {
                        marginTop: ic.s(1),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      stlPfx: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -20,
//                      pfx:`メールアドレスの変更・追加`,
                      pfx:`メールアドレスの変更`,
                      b_vsb: true,
                      d_stlCtas: {
                        marginTop: ic.s(2),
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                        fontSize: ic.s(1.2),
                        fontWeight: 'bold',
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -30,
                      d_stlCtas: {
                        marginTop: ic.s(1),
                      },
                    }),
/*
                    ce.c(cr.InpTree, {
                      key: -40,
                      state: 'sdld_c30rDtlsss',
                      d_stlCtas: {
                        marginTop: ic.s(1),
                      },
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 1,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rig1s', {
                              pfx: 'メールアドレス（主）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                            cf.f('c30rig2s', {
                              pfx: 'メールアドレス（副1）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                            cf.f('c30rig3s', {
                              pfx: 'メールアドレス（副2）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                          ]),
                        },
                      },
                    }),
*/
                    ce.c(cr.InpTree, {
                      key: -40,
                      state: 'sdld_c30rDtlsss',
                      d_stlCtas: {
                        marginTop: ic.s(1),
                        marginLeft: 'auto',
                        marginRight: 'auto',
/*
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'black',
*/
//                        backgroundColor: 'black',
                      },
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
/*
                          b_hzl: true,
                          d_cmns: {
                            n_cnt: 1,
                          },
*/
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rig1s', {
                              pfx: 'メールアドレス（主）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
//                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(4.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  height: (ic.g_dvcMode == 's') ? ic.s(2.4) : null, // here
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                            cf.f('c30rig2s', {
                              pfx: 'メールアドレス（副1）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
//                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(4.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  height: (ic.g_dvcMode == 's') ? ic.s(2.4) : null, // here
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                            cf.f('c30rig3s', {
                              pfx: 'メールアドレス（副2）',
                              b_tail: true,
                              d_hdrs: { n_w: ic.s(12+1), n_h: ic.s(2.4) },
//                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.4) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(4.4) },
                              d_stlCmns: {
                                marginTop: ic.s(1),
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              d_lbls: {
                                d_stlPfxs: {
                                  height: (ic.g_dvcMode == 's') ? ic.s(2.4) : null, // here
                                  fontSize: ic.s(1.2),
                                },
                              },
                              d_stlInps: {
                                fontSize: ic.s(1.2),
                              },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ff.f(global.t?.state.sgcd_stgs?._05010100) ?
                    ce.c(ce.Msg, {
                      key: -50,
                      pfx: global.t?.state.sgcd_stgs?._05010100,
                      d_stlCtas: {
                        //height: ic.s(1) * ((ic.g_dvcMode == 's') ? 1 : 2),
                        //maxWidth: ic.gn_bdyW,
                        width: null,
                        maxWidth: null,
                        minWidth: null,
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginTop: ic.s(2),
//                        borderWidth: ic.b(0.5),
//                        borderColor: ic.g_ccdHP,
                        paddingTop: ic.s(1),
                        paddingBottom: ic.s(1),
                        paddingLeft: ic.s(1),
                        paddingRight: ic.s(1),
//                        backgroundColor: 'pink'
                      },
                      stlPfx: {
                        fontWeight: 'bold',
                        textAlign: 'left',
                      },
                    })
                    : null,

                  ]),

                ],
              },
            }),
          ],
        }
      }
    /* ----------------------------------------------------------------------------------------------------
    団体用 メールアドレス登録
    ---------------------------------------------------------------------------------------------------- */
    : (global.t?.d_viewDefs.class == 'c30v3a' && global.t?.state.sgc_pnlPhs == 'ini') ?
      {
        key: -20,
        d_hdrs: {
          pfx: '',
          d_lefts: {
            b_vsb: false,
          },
        },
        d_bdys: {
          l_clds: [
            ce.c(ce.Pnl, {
              key: -20,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_hdrs: {
                b_vsb: false,
              },
              d_btms: {
                l_clds: [
                  ce.c(ce.Box, {
                    key: -10,
                    stlCta: {
                      minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      width: ic.gn_minBdyW,
                      marginTop: ic.s(0.5), // 20211202
                      marginBottom: ic.s(0.5), // 20211202
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      backgroundColor: 'rgba(255,255,255,0.2)',
                    }
                  }, [
                    ce.c(ce.Btn, {
                      key: -10,
                      pfx: '登録',
//                      b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                      b_vsb: true,
                      o_onPrs: () => {
                        cf.myRN_chgPageMode({
                          mode: 'endEdit',
                        })
                        .then(() => {

/*
                          let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
                          let _c30rc11s = _d_c30rs.d_flds.c30rc11s;
                          let _c30rc31s = _d_c30rs.d_flds.c30rc31s;
                          let _c30rig1s = _d_c30rs.d_flds.c30rig1s;
                          let _c30rig2s = _d_c30rs.d_flds.c30rig2s;
                          let _c30rig3s = _d_c30rs.d_flds.c30rig3s;
                          let _ttl = `メールアドレス登録のご連絡 (${global.t?.state.sgcd_cmnStgs.c20r_pfx})`;
                          let _msg = 
`団体番号：${_c30rc11s}
${_c30rc31s} 様

この度は、メールアドレスのご登録をありがとうございます。
登録されたアドレスをご連絡します。

-----------------------------------------------------------

　登録されたメールアドレス

　主　： ${_c30rig1s}
　副１： ${_c30rig2s}
　副２： ${_c30rig3s}

-----------------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`;

                          const _l_tos = [];
                          if (ff.f(_c30rig1s)) _l_tos.push(_c30rig1s);
                          if (ff.f(_c30rig2s)) _l_tos.push(_c30rig2s);
                          if (ff.f(_c30rig3s)) _l_tos.push(_c30rig3s);
                          const _l_bccs = [ic.g_mail];
                          if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
                          cf.myCB_call_eml(
                            _l_tos,
                            _ttl,
                            _msg,
                            _l_bccs
                          );
*/

                          cf.myRN_savePageStgs({ 
                            sgc_pnlPhs: 'end',
                          });
                        });
                      },
                    }),
                  ]),
                ],
              },
              d_bdys: {            
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                  }, [

                    ce.c(ce.Msg, {
                      key: -20,
                      pfx:`施設予約用メールアドレスの登録`,
                      b_vsb: true,
                      d_stlCtas: {
                        marginTop: ic.s(2),
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                        fontSize: ic.s(1.2),
                        fontWeight: 'bold',
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -25,
                      pfx:
                        (global.t?.state.sdld_c30rDtlsss?.c30r && global.t?.state.sdld_c30rDtlsss?.c30r[0]) ? 
                          `団体名： ${global.t?.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s} 様`
                        : null,
                      n_mgnTop: ic.s(1),
                      d_stlCtas: {
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                        fontSize: ic.s(1.2),
                        fontWeight: 'bold',
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -30,
                      pfx: '施設予約に利用したいメールアドレスを入力ください（主・副1・副2の３つまで登録できます）。',
                      n_mgnTop: ic.s(1),
                      d_stlPfxs: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(cr.InpTree, {
                      key: -40,
                      state: 'sdld_c30rDtlsss',
                      n_mgnTop: ic.s(1),
                      d_stlCtas: {
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      },
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          d_cmns: 
                            ic.g_dvcMode == 's' ?
                              null
                            : {
                              n_cnt: 1,
                            },
                          dd_fldDefss: cf.myRN_getFldDefs([
                            cf.f('c30rig1s', {
                              pfx: 'メールアドレス（主）',
                              d_hdrs: { n_w: ic.s(10) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.2) },
                            }), 
                            cf.f('c30rig2s', {
                              pfx: 'メールアドレス（副1）',
                              d_hdrs: { n_w: ic.s(10) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.2) },
                            }), 
                            cf.f('c30rig3s', {
                              pfx: 'メールアドレス（副2）',
                              d_hdrs: { n_w: ic.s(10) },
                              d_bdys: { n_w: ic.s(16), n_h: (ic.g_dvcMode == 's') ? ic.s(4.4) : ic.s(2.2) },
                            }), 
                          ]),
                        },
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -60,
                      pfx: '【ご注意】\n同じメールアドレスを複数の単体に登録することはできません。団体毎に別のアドレスを登録ください。',
                      n_mgnTop: ic.s(1),
                    }),

                    ce.c(ce.Spr, {
                      key: -70,
                      n_mgnTop: ic.s(1),
                      n_w: ic.gn_minBdyW * 2,
                    }),

                    ce.c(ce.Msg, {
                      key: -80,
                      pfx: '正常にメールアドレスの登録が完了すると、【メールアドレス登録のご連絡】というタイトルの確認メールが5分以内に自動で届きます。',
                      n_mgnTop: ic.s(1),
                    }),

                    ce.c(ce.Msg, {
                      key: -90,
                      pfx: '※ 上記のメールが届かなかった場合、`メールアドレスが正しく登録されていない可能性がございます。その場合は、もう一度最初から、お試しください。',
                      n_mgnTop: ic.s(1),
                    }),


                    ce.c(ce.Msg, {
                      key: -100,
                      pfx: '※ メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、迷惑メールとして判定されていないかのご確認をお願いします。PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は\n「c-supportsys.com」\nから届くメールの受信許可設定をお願いいたします。',
                      n_mgnTop: ic.s(1),
                    }),

                    ce.c(ce.Msg, {
                      key: -110,
                      pfx: '※ 何度試してもうまくメールが登録されない場合は、お手数ですが窓口までご相談ください。',
                      n_mgnTop: ic.s(1),
                    }),

                  ])

                ],
              },
            }),
          ],
        }
      }
    : (global.t?.d_viewDefs.class == 'c30v3a' && global.t?.state.sgc_pnlPhs == 'end') ?
      {
        key: -20,
        d_hdrs: {
          pfx: '',
          d_lefts: {
            b_vsb: false,
          },
        },
        d_bdys: {
          l_clds: [
            ce.c(ce.Pnl, {
              key: -20,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_hdrs: {
                b_vsb: false,
              },
              d_bdys: {            
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                  }, [

                    ce.c(ce.Msg, {
                      key: -20,
                      pfx:`施設予約用メールアドレスの登録`,
                      b_vsb: true,
                      d_stlCtas: {
                        marginTop: ic.s(2),
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                        fontSize: ic.s(1.2),
                        fontWeight: 'bold',
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -25,
                      pfx:
                        (global.t?.state.sdld_c30rDtlsss?.c30r && global.t?.state.sdld_c30rDtlsss?.c30r[0]) ? 
                          `団体名： ${global.t?.state.sdld_c30rDtlsss?.c30r[0].d_flds.c30rc31s} 様`
                        : null,
                      n_mgnTop: ic.s(1),
                      d_stlCtas: {
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                        fontSize: ic.s(1.2),
                        fontWeight: 'bold',
                      },
                    }),

                    ce.c(ce.Msg, {
                      key: -30,
                      pfx: '登録手続きが完了しました。\nブラウザを閉じて終了してください。',
                      n_mgnTop: ic.s(1),
                      d_stlPfxs: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(ce.Spr, {
                      key: -50,
                      n_mgnTop: ic.s(1),
                      n_w: ic.gn_minBdyW * 2,
                    }),

                    ce.c(ce.Msg, {
                      key: -80,
                      pfx: '正常にメールアドレスの登録が完了すると、【メールアドレス登録のご連絡】というタイトルの確認メールが5分以内に自動で届きます。'
                    }),

                    ce.c(ce.Msg, {
                      key: -90,
                      pfx: '※ 上記のメールが届かなかった場合、`メールアドレスが正しく登録されていない可能性がございます。その場合は、もう一度最初から、お試しください。',
                      n_mgnTop: ic.s(1),
                    }),

                    ce.c(ce.Msg, {
                      key: -100,
                      pfx: '※ メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、迷惑メールとして判定されていないかのご確認をお願いします。PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は\n「c-supportsys.com」\nから届くメールの受信許可設定をお願いいたします。',
                      n_mgnTop: ic.s(1),
                    }),

                    ce.c(ce.Msg, {
                      key: -110,
                      pfx: '※ 何度試してもうまくメールが登録されない場合は、お手数ですが窓口までご相談ください。',
                      n_mgnTop: ic.s(1),
                    }),

                  ])

                ],
              },
            }),
          ],
        }
      }
    : null
    )
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
